import script from "./ContactAttributes.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactAttributes.vue?vue&type=script&lang=ts&setup=true"

import "./ContactAttributes.vue?vue&type=style&index=0&id=86384e78&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86384e78"]])

export default __exports__